<div class="fixed-content-page-layout">
  @if (config?.loading) {
    <div class="fixed-content-page-layout-loading">
      <app-loading-spinner
        [config]="loadingSpinnerConfig"
        trackingId="page-loading-spinner"
      />
    </div>
  }

  @if (content) {
    <div
      class="fixed-content-page-layout-content"
      [class.display-hidden]="config?.loading"
      data-ua-id="page-content"
    >
      <ng-container [ngTemplateOutlet]="content"></ng-container>
    </div>
  }

  @if (action) {
    <div
      class="fixed-content-page-layout-action bg-flats-white b-t-border-main"
      [class.display-hidden]="config?.loading"
      data-ua-id="page-action"
    >
      <ng-container [ngTemplateOutlet]="action"></ng-container>
    </div>
  }
</div>
